export default [
    {
      path: 'relatorios/comissoes-promotores',
      name: 'comissoes-promotores',
      component: () => import('./index'),
      meta: {
        visible: true,
        title: 'Comissões Promotores',
        breadcrumb: [
          { name: 'Home', link: 'home' },
          { name: 'Relatórios', link: 'relatorios' },
          { name: 'Comissões Promotores'},
        ]
      }
    }
  ]